module.exports = __webpack_public_path__ + "static/media/profileIconSelected.bc5be0a3.png";